import React from "react";
import * as S from "./styles";
import Card from "./Card";

function Home() {
  return (
    <S.Page>
      <Card
        title="CHI E' IN VOLO"
        url="https://remote.fsairlines.net/v1/flights_active2.php?rvi=49186&title=off"
        height={350}
      />
      <Card
        title="ULTIMI 10 VOLI"
        url="https://remote.fsairlines.net/v1/lastflights.php?rvi=49186&title=off"
        height={350}
      />
      <Card
        title="STATISTICHE PILOTI"
        url="https://remote.fsairlines.net/v1/pilotstats.php?rvi=49186&title=off"
        height={950}
      />
      <Card
        title="STATISTICHE FLOTTA"
        url="https://remote.fsairlines.net/v1/fleetstats.php?rvi=49186&title=off"
        height={350}
      />
    </S.Page>
  );
}

export default Home;
